(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jeje-stock-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jeje-stock-navigation')) {
    customElements.define('jeje-stock-navigation', class extends HTMLElement {
      connectedCallback() {
        const current = new URL(location.href);
        const key = 'filter.v.availability';
        const available = new URL(current);
        available.searchParams.set(key, '1');
        available.searchParams.delete('page');
        available.searchParams.delete('jeje_stock');
        const all = new URL(current);
        all.searchParams.delete(key);
        all.searchParams.delete('page');
        all.searchParams.set('jeje_stock', 'all');
        this.querySelector('[data-stock-available]').href = available.href;
        this.querySelector('[data-stock-all]').href = all.href;
        const firstCollection = this.hasAttribute('data-default-available') && !this.constructor.collectionInitialized;
        if (this.hasAttribute('data-default-available')) this.constructor.collectionInitialized = true;
        if (firstCollection && !current.searchParams.has(key) && current.searchParams.get('jeje_stock') !== 'all') {
          location.replace(available.href);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nuridal-cart-group"] && !Shopify.designMode) return;
  try {
    (() => {
  const variantId = 46014683021491;
  const eligible = item => Number(item.variant_id) === variantId &&
    Object.keys(item.properties || {}).length === 0 && !item.selling_plan_allocation;
  const updatesFor = (items, target) => {
    const keys = [...new Set(items.filter(eligible).map(item => item.key))];
    return Object.fromEntries(keys.map((key, index) => [key, index === 0 ? target : 0]));
  };
  let updating = false;
  const request = async (path, payload) => {
    const response = await fetch((window.Shopify?.routes?.root || '/') + path, {
      credentials: 'same-origin', cache: 'no-store',
      headers: { Accept: 'application/json', ...(payload ? { 'Content-Type': 'application/json' } : {}) },
      ...(payload ? { method: 'POST', body: JSON.stringify(payload) } : {})
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message);
    return result;
  };
  const change = async (group, target) => {
    const input = group.querySelector('[data-nuridal-quantity]');
    const status = group.querySelector('.nuridal-status');
    if (updating || document.querySelector('[data-jeje-choice][aria-busy="true"], cart-form.cart-form--refreshing')) {
      input.value = group.dataset.quantity;
      status.textContent = group.dataset.busy;
      return;
    }
    const max = group.dataset.max === '' ? Infinity : Number(group.dataset.max);
    if (!Number.isInteger(target) || target < 0 || target > max) {
      status.textContent = group.dataset.invalid;
      input.value = group.dataset.quantity;
      return;
    }
    if (target === Number(group.dataset.quantity)) return;
    updating = true;
    status.textContent = group.dataset.busy;
    const controls = [...document.querySelectorAll('[data-nuridal-group] button, [data-nuridal-quantity], #cartform [name="checkout"]')];
    const disabledBefore = controls.map(node => node.disabled);
    controls.forEach(node => { node.disabled = true; });
    group.setAttribute('aria-busy', 'true');
    let quantitySaved = false;
    try {
      const cart = await request('cart.js');
      const updates = updatesFor(cart.items, target);
      if (!Object.keys(updates).length) throw new Error(group.dataset.error);
      const result = await request('cart/update.js', { updates });
      quantitySaved = true;
      const actual = result.items.filter(eligible).reduce((sum, item) => sum + item.quantity, 0);
      if (actual !== target) throw new Error(group.dataset.error);
      const forms = [...document.querySelectorAll('cart-form')];
      const refreshed = await Promise.all(forms.map(async form => {
        const url = new URL(window.Shopify?.routes?.root || '/', window.location.origin);
        url.searchParams.set('section_id', form.dataset.sectionId);
        const response = await fetch(url, { cache: 'no-store' });
        if (!response.ok) throw new Error(group.dataset.error);
        return { form, html: await response.text() };
      }));
      refreshed.forEach(({ form, html }) => form.refreshFromHtml(html));
      document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
    } catch (error) {
      input.value = group.dataset.quantity;
      status.textContent = group.dataset.error;
      document.dispatchEvent(new CustomEvent('on:cart:error', { detail: { error: error.message } }));
      if (quantitySaved) window.location.reload();
    } finally {
      updating = false;
      controls.forEach((node, index) => { if (node.isConnected) node.disabled = disabledBefore[index]; });
      group.removeAttribute('aria-busy');
    }
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-nuridal-action]');
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const group = button.closest('[data-nuridal-group]');
    const current = Number(group.dataset.quantity);
    const action = button.dataset.nuridalAction;
    change(group, action === 'remove' ? 0 : current + (action === 'increase' ? 1 : -1));
  }, true);
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-nuridal-quantity]')) return;
    event.stopImmediatePropagation();
    change(event.target.closest('[data-nuridal-group]'), Number(event.target.value));
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key === 'Enter' && event.target.matches('[data-nuridal-quantity]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      change(event.target.closest('[data-nuridal-group]'), Number(event.target.value));
    }
  }, true);
})();
  } catch(e) { console.error(e); }
})();

})();
